import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useRef } from "react";
import {
  Container,
  Heading3,
  Heading5,
  Icon,
  ImageLite,
  Paragraph,
} from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import styles from "./Content019.module.scss";
import SwiperItem from "./SwiperItem";

export const Content019 = ({ payload }) => {
  const slider = payload?.slider ?? [];
  const template = payload?.backgroundColor ?? "light";
  const imagePosition = payload?.imagePosition ?? "right";
  const { isDesktop } = useViewMode();

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const swiper1Ref = useRef(null);
  const swiper2Ref = useRef(null);

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container className={styles.inner}>
        <div className={styles.content}>
          <div className={styles.sliders}>
            <div className={styles.slider}>
              <SwiperItem
                prevRef={prevRef}
                nextRef={nextRef}
                swiperRef={swiper1Ref}
                autoHeight={true}
                paginationWrapper={styles.pagination}
              >
                {slider.map((item) => (
                  <SwiperSlide key={item.id} className={styles.slide}>
                    <Heading3 color="dark" className={styles.title}>
                      {item.title}
                    </Heading3>
                    <Heading5 color="dark" className={styles.subtitle}>
                      {item.subtitle}
                    </Heading5>
                    <Paragraph color="brand" className={styles.lead}>
                      {item.lead}
                    </Paragraph>
                    <RichText color="dark" value={item.text} />
                  </SwiperSlide>
                ))}
              </SwiperItem>
              <div
                className={classNames(styles["navigation-wrapper"], {
                  [styles["navigation-position"]]: imagePosition === "left",
                })}
              >
                {isDesktop && <div className={styles.pagination}></div>}
                <div className={styles["slider-navigation"]}>
                  <div
                    ref={prevRef}
                    className={classNames(
                      styles.navigation,
                      styles["navigation-prev"]
                    )}
                  >
                    <Icon className={styles.icon} name="arrow_slider_prev" />
                  </div>
                  <div
                    ref={nextRef}
                    className={classNames(
                      styles.navigation,
                      styles["navigation-next"]
                    )}
                  >
                    <Icon className={styles.icon} name="arrow_slider_next" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className={classNames(styles.slider, {
                [styles["slider-image"]]: imagePosition === "left",
              })}
            >
              <SwiperItem
                prevRef={prevRef}
                nextRef={nextRef}
                swiperRef={swiper2Ref}
              >
                {slider?.map((item) => (
                  <SwiperSlide key={item.id} className={styles.slide}>
                    <ImageLite
                      image={item.image?.[0]}
                      className={styles.image}
                    />
                  </SwiperSlide>
                ))}
              </SwiperItem>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content019;
